/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APITokenPartialUpdate
 */
export interface APITokenPartialUpdate {
    /**
     * 
     * @type {string}
     * @memberof APITokenPartialUpdate
     */
    name?: string;
}

export function APITokenPartialUpdateFromJSON(json: any): APITokenPartialUpdate {
    return APITokenPartialUpdateFromJSONTyped(json, false);
}

export function APITokenPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): APITokenPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function APITokenPartialUpdateToJSON(value?: APITokenPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


